import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const FireIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
    fill="none"
  >
    <Path
      d="M18.8088 12.4822L18.7972 12.4347C17.0766 6.95558 11.9498 3.06565 11.7318 2.90356L11.0701 2.40942L11.1129 3.23957C11.1129 3.27518 11.2336 6.49308 8.16219 9.16936C4.82613 12.0789 4.84556 14.4785 4.85338 15.7673L4.85733 15.9452C4.85733 19.4596 7.39696 22.0872 11.0304 22.5204C10.8326 22.4889 10.6305 22.4479 10.4278 22.385C9.25605 22.0173 8.57097 21.1832 8.43861 19.9814L8.40749 19.7442C8.30237 18.8152 8.16614 17.6648 10.167 15.4827C10.9144 14.6683 11.5645 13.7907 12.1017 12.8775L12.3703 12.4189L12.7245 12.8142C13.7833 13.9883 14.593 15.1743 15.138 16.3286C15.6401 17.3486 15.6713 18.9615 15.6323 19.3054C15.4416 21.0606 14.192 22.3692 12.5181 22.5589C12.409 22.5715 12.2457 22.5838 12.0458 22.5883C12.0634 22.5884 12.0801 22.5905 12.0978 22.5905C16.0527 22.5905 19.1474 19.3607 19.1474 15.2375C19.1475 14.2493 18.8205 12.5533 18.8088 12.4822Z"
      fill={color}
    />
  </Svg>
);

export default FireIcon;
